/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import vuetify from "./plugins/vuetify"; // Ensure this path is correct
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  mounted: function () {
    window.onpopstate = () => {
      window.scrollTo(0, 0);
    };
  },
  render: (h) => h(App),
}).$mount("#app");
